import React, {useEffect, useState} from "react";
import Header from "../components/Header";
import {useParams, useSearchParams} from "react-router-dom";
import Footer from "../components/Footer";
import "react-datepicker/dist/react-datepicker.css";
import {Badge} from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";

function PurchaseTicketConfirmation() {
    const {id} = useParams();
    const [area, setArea] = useState(null);
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [ticket, setTicket] = useState();

    const status_payment = searchParams.get("status") === "true"; // Ottiene il valore della query string
    const error_payment = searchParams.get("error"); // Ottiene il valore della query string
    useEffect(() => {
        if (typeof id === "undefined")
            return;
        fetch(global.route.ticketInfo, {
            method: 'POST',
            credentials: 'include',
            body: global.getFormData(
                {id: id}
            )
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Errore nella richiesta");
                }
                return response.json();
            })
            .then((data) => {
                setTicket(data.ticket);
                setArea(data.area);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
            });
    }, [id]);


    let getTicketInfo = () => {
        if (ticket === null || ticket === undefined)
            return;
        let description = null;
        if (ticket.description !== null)
            description = ticket.description;
        else if (area.full_description !== null)
            description = area.full_description;
        else if (ticket.society.description !== null)
            description = ticket.society.description;

        return <div style={{backgroundColor: "#fafafa", color: "#212121"}}>
            <div className={"container p-2"}>
                <div className={"d-flex "} style={{justifyContent: "space-between"}}>

                    <div style={{flex: 1}}>
                        <h3>{ticket.name}</h3>
                    </div>
                    <Badge bg={"success"} style={{
                        fontSize: 16,
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}>{ticket.price.toFixed(2)}€</Badge>
                </div>
                <b className={"orange"}>{global.getNameTicketType(ticket.type)}</b><br/>
                <span>Categoria {ticket.ticket_residence_type.name}</span><br/>

                <Badge bg="dark">Valido dal {ticket.date_start_validity}</Badge>
                <Badge style={{marginLeft: 4}} bg="dark">Valido fino al {ticket.date_end_validity}</Badge><br/>
                <div className="mt-2" dangerouslySetInnerHTML={{__html: description}}/>
            </div>
        </div>
    }

    function getStatusPayment() {
        if (status_payment) {
            return <Alert variant={"success"}><h4>Acquisto Completato</h4>
                Congratulazioni per la tua nuova avventura, ti auguriamo una buona giornata!<br/><br/>
                <div className={"d-flex justify-content-center align-items-center"}><b className={"p-2"}>Puoi scaricare il permesso acquistato dal profilo</b> <Button className={"btn-orange"}
                                                                          href={"/user/tickets"}>Lista permessi</Button></div>
            </Alert>;
        } else {
            return <Alert variant={"danger"}><h4>Acquisto non completato</h4>
                Qualcosa è andato storto durante la transazione e il pagamento non è andato a buon fine.<br/> Ci dispiace per
                l'inconveniente, si prega di riprovare.<br/>{error_payment}<br/>
                <div className={"d-flex justify-content-center justify-content-center align-items-center"}>
                    <Button className={"btn-orange"} href={"/event/"+id}>Riprova</Button></div>
            </Alert>;
        }
    }

    return (<div style={{backgroundColor: "#fafafa"}} className={"area-info"}>
        <Header/>
        <div style={{backgroundColor: "#EEEEEE", marginTop: 86, minHeight: "70vh"}}>
            {getTicketInfo()}
            <div className="container pt-4 pb-4">
                <div className="row">
                    {getStatusPayment()}
                </div>
            </div>
        </div>
        <Footer/>
    </div>);
}

export default PurchaseTicketConfirmation;